'use strict';

const AOS = require('aos/dist/aos.js');

function init() {
    AOS.init({
    	once: true
    });
}

module.exports = {
    init: init
};
